import { MovedPermanentlyManifest } from '@gaming1/g1-core-web';

export const goneUrls = ['/en/gone'];

export const movedUrls: MovedPermanentlyManifest = [
  ['/en/moved', '/en/casino-games/all-a'],
];
